import { Parking } from "../generated/graphql"

export const ParkingLabels = {
  [Parking.Assigned]: "Assigned",
  [Parking.Shared]: "Shared",
  [Parking.Garage]: "Garage",
  [Parking.Other]: "Other",
  [Parking.None]: "None"
}
